import React from 'react';
import Icon from '../../../components/AppIcon';

const RecoveryScoreCard = ({ title, value, average, icon, color, suffix = '' }) => {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary',
    blue: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
    red: 'bg-red-500/10 text-red-600 dark:text-red-400',
    pink: 'bg-pink-500/10 text-pink-600 dark:text-pink-400',
    green: 'bg-green-500/10 text-green-600 dark:text-green-400'
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4">
      <div className="flex items-center gap-2 mb-3">
        <div className={`w-8 h-8 rounded-lg ${colorClasses?.[color]} flex items-center justify-center`}>
          <Icon name={icon} size={16} />
        </div>
        <h3 className="text-xs font-medium text-muted-foreground">{title}</h3>
      </div>
      <div className="mb-1">
        <span className="text-2xl font-bold text-foreground">{value}</span>
        <span className="text-sm text-muted-foreground ml-1">{suffix}</span>
      </div>
      {average !== null && average !== undefined && (
        <p className="text-xs text-muted-foreground">
          Avg: {average}{suffix}
        </p>
      )}
    </div>
  );
};

export default RecoveryScoreCard;